import axios from 'axios';
import { RoomData } from '../types/room.types';

//const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://admin.villasflamingos.com/api';

export const RoomService = {
    /**
     * Obtiene una habitación por su slug
     * @param slug El identificador de la URL (ej: 'vista-mar')
     * @param language El idioma actual ('es' o 'en')
     */
    getBySlug: async (slug: string, language: string): Promise<RoomData> => {
        const response = await axios.get<{ data: RoomData }>(`${BASE_URL}/rooms/${slug}`, {
            headers: {
                'Accept-Language': language,
                'Content-Type': 'application/json',
            },
        });
        console.log(response.data.data);
        return response.data.data;
    },

    /**
     * Obtiene TODAS las habitaciones para el comparador
     */
    getAll: async (language: string): Promise<RoomData[]> => {
        const response = await axios.get<{ data: RoomData[] }>(`${BASE_URL}/rooms`, {
            headers: {
                'Accept-Language': language,
                'Content-Type': 'application/json',
            },
        });
        return response.data.data;
    }
};